import React, { useEffect, useState } from "react";
import { useSchedulerContext } from "../context/SchedulerContext";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Container, Row, Col } from "react-bootstrap";
import Modalcmp from "../modal/Modalcmp";
import CreateEvent from "./CreateEvent";
import UpdateEvent from "./UpdateEvent";
import ModalReusable from "../modal/ModalReusable";
import Sidebar from "./components/Sidebar";

const localizer = momentLocalizer(moment);
const Scheduler = () => {
  const { eventsData, setModal, setModalChildren } = useSchedulerContext();
  const [modalTitle, setModalTitle] = useState();
  const [slotInfo, setSlotInfo] = useState("");
  const [event, setEvent] = useState("");

  const handleSelect = (slotInfo) => {
    setEvent("");
    setModal(true);
    setSlotInfo(slotInfo);
    // setModalChildren(<CreateEvent slotInfo={slotInfo}/>)
    setModalChildren("create");
    setModalTitle("Create Event");
  };

  const handleEventSelect = (event) => {
    // setModalChildren(<UpdateEvent event={event}/>)
    setEvent(event);
    setModal(true);
    setModalChildren("update");
    setModalTitle("Update Event ");
  };

  console.log("events", eventsData);
  return (
    <>
      <Container>
        <Row>
          {/* <Col xs={6} md={3}>
            <Sidebar />
          </Col> */}
          {/* <Col xs={12} md={9}> */}
          <Container>
            <div className="calendar">
              <Calendar
                localizer={localizer}
                defaultDate={new Date()}
                defaultView="month"
                startAccessor={(event) => {
                  return new Date(event.start);
                }}
                selectable={true}
                endAccessor={(event) => {
                  return new Date(event.end);
                }}
                events={eventsData}
                onSelectEvent={(event) => handleEventSelect(event)}
                onSelectSlot={(slotInfo) => handleSelect(slotInfo)}
              />
            </div>

            {/* <Modalcmp  title={modalTitle} /> */}
            <ModalReusable
              title={modalTitle}
              slotInfo={slotInfo}
              event={event}
            />
          </Container>
          {/* </Col> */}
        </Row>
      </Container>
    </>
  );
};

export default Scheduler;
